import React from 'react';

import { NodeDataPoint } from './SankeyNodes';

interface SankeyLabelProps {
  x: number;
  y: number;
  dy: string;
  text: string;
  width: number;
}

export const SankeyNodeLabelComponent = ({
  text,
  width,
  ...textProps
}: SankeyLabelProps): JSX.Element => {
  return (
    <div style={{ position: 'absolute', top: textProps.y, left: textProps.x, width: width }}>
      {text}
    </div>
  );
};

export const isFilledSankeyNode = (node: NodeDataPoint): node is Required<NodeDataPoint> => {
  return (
    node.x0 !== undefined && node.x1 !== undefined && node.y0 !== undefined && node.y1 !== undefined
  );
};

const getTextProps = ({ x0, x1, y0, y1 }: Required<NodeDataPoint>, width: number, isLTR) => {
  const x = isLTR ? x0 : x1 - 335; // -15 is label box padding
  const y = y0 + 38;

  return {
    x,
    y,
    dy: '0.35em',
  } as const;
};

interface SankeyNodeLabelsProps {
  nodes: NodeDataPoint[];
  width: number;

  textFunc?(node: NodeDataPoint): string | React.ReactNode;

  isLTR?: boolean;
}

export const SankeyNodeLabelsComponent = ({
  nodes,
  width,
  textFunc,
  isLTR,
}: SankeyNodeLabelsProps): JSX.Element => {
  return (
    <div style={{ fontSize: 10 }}>
      {nodes.map((node) => {
        if (!isFilledSankeyNode(node)) return null;
        const textProps = getTextProps(node, width, isLTR);

        const text = textFunc?.(node) || node.tokenData.address;

        return <SankeyNodeLabelComponent {...textProps} width={width} text={text} key={node.id} />;
      })}
    </div>
  );
};
